import { ReactElement } from "react";

import logo from "images/sapphire_logo_vertical.png";
import logo2x from "images/sapphire_logo_vertical@2x.png";

export function Logo(): ReactElement | null {
  return (
    <img
      src={logo}
      srcSet={`${logo}  1x, ${logo2x}  2x`}
      alt="SAPPHIRE Logo"
      height="28"
    />
  );
}
